import { useSelect as useCoins } from '@/pages/finance/coin/api';
import { Select, SelectProps } from '@arco-design/web-react';
import React from 'react';

export const SelectCoin = ({
  value,
  onChange,
  placeholder = '全部',
  useName = false,
  addThird = false,
  ...rest
}: SelectProps & {
  useName?: boolean;
  addThird?: boolean;
}) => {
  const { data, isLoading } = useCoins({
    params: {
      pageSize: 100,
      pageIndex: 1,
    },
  });

  const options = data
    ? data.data.items.map((v) => ({
        label: v.display_name,
        value: useName ? v.name : v.id,
      }))
    : [];
  if (addThird) {
    options.push(
      ...[
        {
          label: '三方支付',
          value: 'THIRD',
        },
        // {
        //   label: '银行卡支付',
        //   value: 'CARD',
        // },
      ]
    );
  }
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={isLoading}
      {...rest}
      options={options}
      allowClear
    />
  );
};
